import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_RPSET',
    fieldMap: {
        id              : 'CIRPS_ID',
        statusId        : 'CIRPS_CIST_ID',
        origin          : 'CIRPS_ORIGIN',
        module          : 'CIRPS_MODULE',
        referenceSetId  : 'CIRPS_CIRS_ID',
        propertyTypeId  : 'CIRPS_CIPT_ID',
        valueSetId      : 'CIRPS_CIVS_ID',
        description     : 'CIRPS_DESCRIPTION',
        keyType         : 'CIRPS_KEY_TYPE',
        keyDefinition   : 'CIRPS_KEY_DEFINITION',
        keyExample      : 'CIRPS_KEY_EXAMPLE',
        valueType       : 'CIRPS_VALUE_TYPE',
        valueDefinition : 'CIRPS_VALUE_DEFINITION',
        valueExample    : 'CIRPS_VALUE_EXAMPLE',
        valueDefault    : 'CIRPS_VALUE_DEFAULT',
        valueMin        : 'CIRPS_VALUE_MIN',
        valueMax        : 'CIRPS_VALUE_MAX',
        valueUnit       : 'CIRPS_VALUE_UNIT',
        isEnumerated    : 'CIRPS_IS_ENUMERATED',
        isImported      : 'CIRPS_IS_IMPORTED',
        modifierUserId  : 'CIRPS_MODIFIER',
        modificationTime: 'CIRPS_MODIFICATION_TIME',
        uuid            : 'CIRPS_UUID'
    }
};

export default tableDefinition;
